/** Relative timestamps and icons for group activity feed (no money fields). */

export function activityTimestampMs(event) {
  const value = event?.createdAt;
  if (!value) return null;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value === 'number') return value;
  if (typeof value.seconds === 'number') return value.seconds * 1000;
  return null;
}

export function formatRelativeTimestamp(ms) {
  if (!ms) return 'Just now';
  const diff = Math.max(0, Date.now() - ms);
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

const ACTIVITY_ICONS = {
  lock_posted: '🔒',
  lock_accepted: '✅',
  member_defeated: '🏆',
  weekly_champion: '👑',
  member_joined: '👋',
  member_left: '↩️',
  group_created: '✨',
  ownership_transferred: '👑',
};

export function activityIcon(type) {
  return ACTIVITY_ICONS[type] || '•';
}
